//import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

//import AboutResourceCard from './components/AboutResourceCard';
import Utterances from './components/Utterances';
import ChatBotModal from 'components/theach/ChatBotModal';
import Button from 'components/base/Button';
import apiClient from 'helpers/apiService';
import { useState, useEffect, useMemo } from 'react';
import { ResourceTranscriptionInfo, UtteranceItem } from './components/DataDefinitions';
import AnalysisView from '../../components/theach/meetings/AnalysisView';


import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import { MeetingContacts, MeetingSummary } from 'components/theach/meetings/MeetingComponents';
import ICFAnalysisView from 'pages/analytics/components/ICFAnalysisView';


const ConversationDetails = () => {

    const { t } = useTranslation();
    // Route parameters
    const { conversation_type, resource_id } = useParams();


    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Meetings'),
            url: '/effective-communication'
        },
        {
            label: conversation_type === 'group' ? t('TeamConversations.page_title') : t('IndividualConversations.page_title'),
            url: `/effective-communication/${conversation_type}`
        },
        {
            label: t('Meeting Details'),
            active: true
        }
    ];

    const [resourceTranscriptionInfo, setResourceTranscriptionInfo] = useState<ResourceTranscriptionInfo>({
        resource: {
            resource_id: '',
            resource_meta: '',
            resource_name: ''
        },
        transcription: {}
    });

    const [utterances, setUtterances] = useState<UtteranceItem[]>([]);

    const [audioUrl, setAudioUrl] = useState('');
    const [summaryPoints, setSummaryPoints] = useState<string[]>([]);

    const [analysis, setAnalysis] = useState('');
    const [icfAnalysis, setICFAnalysis] = useState<string>();



    const [showFeedbackTab, setShowFeedbackTab] = useState<boolean>(false);
    const [showICFFeedbackTab, setShowICFFeedbackTab] = useState<boolean>(false);
    const [loading, setLoading] = useState(true);

    // is a group meeting or a 1-2-1?
    const groupMeeting = useMemo(() => {
        if (resourceTranscriptionInfo.transcription === undefined) {
            return false;
        }

        if (resourceTranscriptionInfo.transcription.number_of_speakers === '-') {
            return false;
        }

        if (resourceTranscriptionInfo.transcription.number_of_speakers && parseInt(resourceTranscriptionInfo.transcription.number_of_speakers) > 2) { return true; }

        return false;
    }, [resourceTranscriptionInfo]);

    const fetchResourceTranscriptionData = async () => {
        //console.log("Get resource & transcription data - fetch data: " + resource_id);

        // initialization
        //setShowFeedbackTab(false);
        setShowICFFeedbackTab(false);

        try {
            const response = await apiClient.get(`/v1/conversations/${resource_id}/transcription`);

            if (response.status === 200) {
                const rt: ResourceTranscriptionInfo = {
                    resource: {
                        resource_id: '',
                        resource_meta: '',
                        resource_name: ''
                    },
                    transcription: {}
                };
                /*
                inserted_at: "09/04/2024 22:00:40"
                resource_id:8
                resource_meta:"{\"content-type\": \"audio/x-m4a\", \"file-size\": 7885444, \"status\": \"transcribing\", \"nonce\": \"f494939ebf874aab97d72c1c629708ab\"}"
                resource_name:"T # 15_3.m4a"
                */
                rt.resource.resource_id = response.data.resource_id;
                rt.resource.resource_name = response.data.resource_name;
                rt.resource.resource_meta = response.data.resource_meta; // JSON string                

                setShowICFFeedbackTab(JSON.parse(rt.resource.resource_meta)['icf-feedback'] === 'ready');

                if (JSON.parse(rt.resource.resource_meta)['default-feedback'] === 'ready')
                    await retrieveDefaultFeedbackChangeTab();

                if (response.data.transcription_id !== null) {
                    rt.transcription.transcription_id = response.data.transcription_id;

                    rt.transcription.transcription_meta = response.data.transcription_meta;
                    rt.transcription.transcription_status = response.data.transcription_status;
                    if (rt.transcription.transcription_status === 'completed') {
                        //setTranscriptionInProgress(false);
                        const transcription_content = JSON.parse(response.data.transcription_content);
                        rt.transcription.utterances = transcription_content.utterances;
                        setUtterances(transcription_content.utterances);
                        /**
                         * 
                        transcription_meta: "{\"language_code\": \"en_us\", \"audio_url\": \"https://c\", \"punctuate\": true, \"format_text\": true, \"dual_channel\": false, \"webhook_url\": \"https://theach.wideopen.store/v1/theach/webhook?customer_id=1&row_id=6&nonce=402e063f6dcb4db98f2358dc6562547c\", \"webhook_auth_header_name\": null, \"webhook_auth_header_value\": null, \"audio_start_from\": null, \"audio_end_at\": null, \"word_boost\": [], \"boost_param\": null, \"filter_profanity\": false, \"redact_pii\": false, \"redact_pii_audio\": false, \"redact_pii_policies\": null, \"redact_pii_sub\": null, \"speaker_labels\": true, \"speakers_expected\": null, \"content_safety\": false, \"content_safety_confidence\": null, \"iab_categories\": false, \"custom_spelling\": null, \"disfluencies\": false, \"sentiment_analysis\": false, \"auto_chapters\": false, \"entity_detection\": false, \"summarization\": false, \"summary_model\": null, \"summary_type\": null, \"auto_highlights\": false, \"language_detection\": false, \"speech_threshold\": null, \"speech_model\": null, \"id\": \"f926e1cb-d536-4f40-afcc-1bd4600e4273\", \"status\": \"queued\", \"error\": null, \"text\": null, \"words\": null, \"utterances\": null, \"confidence\": null, \"audio_duration\": null, \"webhook_status_code\": null, \"webhook_auth\": false, \"summary\": null, \"auto_highlights_result\": null, \"content_safety_labels\": null, \"iab_categories_result\": null, \"chapters\": null, \"sentiment_analysis_results\": null, \"entities\": null}"
                        transcription_status: "completed"
                         */
                        const transcription_meta = JSON.parse(response.data.transcription_meta);
                        rt.transcription.language = transcription_meta.language_code;
                        rt.transcription.number_of_speakers = transcription_meta.number_of_speakers;

                        if (response.data.speakers !== null) {
                            const speakers = JSON.parse(response.data.speakers);
                            rt.transcription.speakerA = speakers.speakerA;
                            rt.transcription.speakerB = speakers.speakerB;
                        }
                    }
                }
                setResourceTranscriptionInfo(rt);
            }
        } catch (error) {
            console.error('Error fetching ResourceTranscriptionInfo data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAudio = async () => {
        try {
            // Make a GET request to fetch the audio file from the backend
            const response = await apiClient.get(`/v1/conversations/${resource_id}/audio`);
            // get preassigned url from S3
            setAudioUrl(response.data);
        } catch (error) {
            console.error('Error fetching audio:', error);
        }
    };

    const fetchSummary = async () => {
        try {
            // Make a GET request to fetch the summary from the backend
            const response = await apiClient.get(`/v1/ai/resource/${resource_id}/summary`);

            if (response.status == 200 && response.data.status === 'completed')
                setSummaryPoints(response.data.result.split('\n'));

        } catch (error) {
            console.error('Error fetching summary:', error);
        }
    };

    /*
    const onSaveResourceTranscriptionData = async (filename: string, language: string, isSpeakerACoach: boolean, isSpeakerBCoach: boolean) => {
        console.log("onSaveResourceTranscriptionData");
        if (resourceTranscriptionInfo !== undefined) {
            if (filename !== '')
                resourceTranscriptionInfo.resource.resource_name = filename.trim();

            console.log(isSpeakerACoach);
            console.log(isSpeakerBCoach);
            if (isSpeakerACoach === false && isSpeakerBCoach === false) {
                resourceTranscriptionInfo.transcription.speakerA = "";
                resourceTranscriptionInfo.transcription.speakerB = "";
            } else {
                resourceTranscriptionInfo.transcription.speakerA = isSpeakerACoach ? "coach" : "client";
                resourceTranscriptionInfo.transcription.speakerB = isSpeakerBCoach ? "coach" : "client";
            }
            resourceTranscriptionInfo.transcription.language = language;
            setResourceTranscriptionInfo({ ...resourceTranscriptionInfo }); // create a copy using spread operator

            try {
                // Send the file to the backend using Axios
                const response = await apiClient.patch( `/v1/conversations/${resource_id}/transcription/${resourceTranscriptionInfo.transcription.transcription_id}`,
                    {
                        'filename': filename ?? '',
                        'speakerA': resourceTranscriptionInfo.transcription.speakerA,
                        'speakerB': resourceTranscriptionInfo.transcription.speakerB,
                        'language': language
                    },
                    {
                        headers: {
                            
                        },
                        withCredentials: true,
                    });
                console.log('Resource & transcription updated sent to backend', response.data);

            } catch (error) {
                console.error('Error uploading file:', error);
            }

        }

    }
    */

    const handleAnalyzeTranscription = async (resource_id: string, transcription_id: string, type: string) => {
        /**
         * Get a feedback on the given conversation
         */
        //console.log("analyze resource_id:" + resource_id + " - " + transcription_id + " - " + type);
        try {
            // Send the file to the backend using Axios
            // ALT+96 -> `
            const response = await apiClient.post(`/v1/theach/analyze/${resource_id}` + (type === 'ICF' ? '/icf' : ''));

            if (response.status === 200) {
                // Create a copy of resourceTranscriptionInfo
                const rt: ResourceTranscriptionInfo = { ...resourceTranscriptionInfo };
                rt.resource.resource_meta = JSON.stringify(response.data.meta);
                setResourceTranscriptionInfo(rt);
                if (response.data.source === 'theach') {
                    setICFAnalysis(JSON.stringify(response.data.feedback)); // convert into a JSON string
                    setShowICFFeedbackTab(true);
                }
                else
                    console.log("Non implementato");
            }

        } catch (error) {
            console.error('Error requesting feedback:', error);
        }
    };



    const handleChangeTab = async (eventKey: any) => {
        //console.log("handleChangeTab:" + eventKey);
        if (eventKey === 'transcript' && utterances !== null) {
            setUtterances([...utterances]); // create a copy using spread operator
        }

        if (eventKey === 'icfFeedback') {

            const response = await apiClient.get(`/v1/analysis/resource/${resource_id}/icf`);
            if (response.status === 200) {
                //console.log(response.data['result']);
                setICFAnalysis(response.data['result']);
            }


        }

        if (eventKey === 'feedback') {
            await retrieveDefaultFeedbackChangeTab();
        }

    };

    const handleExportTranscription = async (format: string) => {
        /**
         * Get a feedback on the given conversation
         */
        try {
            // Send the file to the backend using Axios
            // ALT+96 -> `
            const response = await apiClient.get(`/v1/conversations/${resource_id}/transcription/download-${format}`, {
                headers: {

                },
                withCredentials: true,
                responseType: 'blob', // Important for handling binary data
            });

            // Create a link element, set the href to the Blob URL, and trigger a download

            let fileType = 'application/pdf';
            if (format === 'docx')
                fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';


            const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.' + format); // Set the file name
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error requesting feedback:', error);
        }
    };

    const retrieveDefaultFeedbackChangeTab = async () => {
        try {
            const response = await apiClient.get(`/v1/analysis/resource/${resource_id}/default`);

            if (response.status === 200) {
                setAnalysis(response.data['result']);
            }

        } catch (error) {
            console.error('Request retrieveDefaultFeedbackChangeTab failed:', error);
        }
    };


    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        //setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        fetchSummary();
        fetchResourceTranscriptionData();
        fetchAudio();
    }, []);


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            {/* 
            <div className="d-flex justify-content-end" >
                <Dropdown className="me-2">
                    <Dropdown.Toggle
                        variant="phoenix-secondary"
                        className="dropdown-caret-none px-3"
                    >
                        <FontAwesomeIcon icon={faEllipsis} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ zIndex: 9999 }} >
                        <Dropdown.Item href="#!" onClick={() => handleExportTranscription('pdf')}>Export transcript in PDF</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <Button variant="phoenix-primary" className="px-6" onClick={() => navigate(-1)} >
                    {t('Back')}
                </Button>
            </div>
*/}
            <Card className='mt-3 mb-3 border border-light rounded-5' >
                <Card.Body>
                    <div className="mx-4 mt-1">
                        <Row>
                            <Tabs
                                defaultActiveKey="conversation"
                                id="uncontrolled-tab-example"
                                className="mb-3 nav-underline"
                                onSelect={handleChangeTab}
                            >

                                <Tab eventKey="conversation" title="Conversation" >
                                    <Row className="mb-2">
                                        <div className="d-flex flex-column">
                                            <MeetingSummary summaryPoints={summaryPoints} className="mt-2 mb-2" />
                                            {analysis && <AnalysisView analysis={analysis} className='mt-2 mb-2' />}
                                        </div>
                                    </Row>

                                    <Row className="mb-2">
                                        <Col>
                                            {resourceTranscriptionInfo.transcription && (
                                                <MeetingContacts transcription={resourceTranscriptionInfo.transcription}
                                                />
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className="mb-4">
                                        <Col md={7} xl={7}>
                                            {resourceTranscriptionInfo?.transcription.utterances &&
                                                <Utterances onStartAnalysis={handleAnalyzeTranscription}
                                                    resource_id={resource_id ?? ''}
                                                    data={resourceTranscriptionInfo}

                                                    //transcription_id={resourceTranscriptionInfo.transcription.transcription_id || ""}
                                                    //resource_meta={resourceTranscriptionInfo.resource.resource_meta}

                                                    audioUrl={audioUrl}
                                                    utterances={utterances}
                                                    speakers={{}}
                                                    //speakerB={resourceTranscriptionInfo?.transcription.speakerB ?? null}
                                                    groupMeeting={groupMeeting}
                                                />}

                                        </Col>

                                        <Col md={5} xl={5} className="d-none d-md-block">
                                            {resource_id && resourceTranscriptionInfo?.transcription.transcription_status === 'completed' && <ChatBotModal resource_id={resource_id} />}
                                        </Col>
                                    </Row>

                                    <Row className="mb-2">

                                        <Col md={12} xl={12}>
                                            <div className="d-flex flex-column">
                                                <Card className='w-100'>
                                                    <Card.Body>
                                                        <Card.Title> <h3>{t("ConversationDetails.notes")}</h3> </Card.Title>
                                                        <Card.Text>
                                                            <Form.Control
                                                                as="textarea"
                                                                style={{ height: '128px' }}
                                                                type="text"
                                                                name='notes' onChange={handleNotesInputChange} />

                                                            <div className="text-end">
                                                                <Button type="submit" variant="primary" className='mt-2'>{t("ConversationDetails.save_notes")}</Button>
                                                            </div>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                </Tab>

                                {showFeedbackTab &&
                                    <Tab eventKey="feedback" title={t("ConversationDetails.Feedback")} >
                                        <AnalysisView analysis={analysis} onRefresh={() => handleChangeTab('feedback')} className='bg-white' />
                                    </Tab>
                                }

                                {showICFFeedbackTab &&
                                    <Tab eventKey="icfFeedback" title={t("ConversationDetails.ICFFeedback")} >
                                        {!icfAnalysis && <div>Loading...</div>}
                                        {icfAnalysis && <ICFAnalysisView analysis={icfAnalysis} onRefresh={() => handleChangeTab('icfFeedback')} className='bg-white' />}
                                    </Tab>
                                }


                            </Tabs>
                        </Row>
                    </div>
                </Card.Body>
            </Card>
        </>
    );

};

export default ConversationDetails;
